import layout from './layout'
import summary from './summary'

export default {
  layout,
  summary
}
